export var verbs = [{
    text: 'のります',
    trans: 'to board',
    group: 2
}, {
    text: 'かります',
    trans: 'to borrow',
    group: 1
}, {
    text: 'きます',
    trans: 'to come',
    group: 1
}, {
    text: 'しにます',
    trans: 'to die',
    group: 2
}, {
    text: 'おります',
    trans: 'to get off',
    group: 1
}, {
    text: 'あげます',
    trans: 'to give',
    group: 1
}, {
    text: 'かします',
    trans: 'to lend',
    group: 1
}, {
    text: 'つくります',
    trans: 'to make',
    group: 2
}, {
    text: 'あいます',
    trans: 'to meet',
    group: 2
}, {
    text: 'あそびます',
    trans: 'to play',
    group: 2
}, {
    text: 'もらいます',
    trans: 'to receive',
    group: 2
}, {
    text: 'みます',
    trans: 'to see',
    group: 1
}, {
    text: 'すわります',
    trans: 'to sit',
    group: 2
}, {
    text: 'ねます',
    trans: 'to sleep',
    group: 1
}, {
    text: 'たちます',
    trans: 'to stand',
    group: 2
}, {
    text: 'およぎます',
    trans: 'to swim',
    group: 2
}, {
    text: 'つかいます',
    trans: 'to use',
    group: 2
}, {
    text: 'おしえます',
    trans: 'to teach',
    group: 1
}, {
    text: 'おきます',
    trans: 'to wake up',
    group: 1
}, {
    text: 'きます',
    trans: 'to wear',
    group: 1
}, {
    text: 'はたらきます',
    trans: 'to work',
    group: 2
}, {
    text: 'かきます',
    trans: 'to write',
    group: 2
}];